export default __webpack_public_path__ + "static/media/logo-size-18px-colour-light-efefef.e759417b.svg";